import React, { Component } from 'react'
// import Spinner from 'react-spinkit'
import { CSSTransitionGroup } from 'react-transition-group'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import i18n from '../i18n.json'

import AboutLogo from '../containers/AboutLogo'
import SectorSelector from '../containers/SectorSelector'
import ValuesSelector from '../containers/ValuesSelector'
import EmotionsSelector from '../containers/EmotionsSelector'
import TypeSelector from '../containers/TypeSelector'
// import ColorPalettesSelector from '../containers/ColorPalettesSelector'
// import TypefacesSelector from '../containers/TypefacesSelector'
import KeywordsSelector from '../containers/KeywordsSelector'
import LogoPreview from '../containers/LogoPreview'
import LogoDownload from '../containers/LogoDownload'
import Sign from '../containers/Sign'

const MAX_STEPS = 8

const hasIt = (it) => {
  if (it.length) {
    if (it.length > 0) return true
  }
  return false
}

class NewLogo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentStep: props.newLogo.currentStep,
      userLocation: null
    }
  }

  componentDidMount() {
    if (this.state.userLocation) return
    let url = 'https://freegeoip.net/json/'
    fetch(url)
      .then((response) => response.json())
      .then((responseJson) => {
        let { country_code } = responseJson
        if (country_code) {
          if (country_code === 'BR')
            this.props.updateLanguage('pt')
          else
            this.props.updateLanguage('en')
          this.setState({
            userLocation: country_code
          })
        }
      })
      .catch((error) => {
        // console.error(error)
      })
  }

  renderStepsSelector() {
    let {
      selectedLanguage,
      selectedValues,
      selectedEmotions,
      selectedSector,
      selectedType,
      // selectedColorPalettes,
      // selectedTypefaces,
      selectedLogoPreviews,
      // selectedKeywords
    } = this.props.newLogo.userPrefs
    let hasLogoPreviews = (selectedLogoPreviews != null) && (selectedLogoPreviews >= 0)
    let { currentStep } = this.props.newLogo
    // let hasItKeywords = false
    // if (selectedKeywords) {
    //   for (let i = 0; i < selectedKeywords.length; i++) {
    //     if (selectedKeywords[i] !== "") hasItKeywords = true
    //   }
    // }

    // { (currentStep >= 6) || hasItKeywords ?
    //       <li className="nav-large selected">
    //           <a href="/step_keywords" onClick={ (evt) => { evt.preventDefault(); this.props.stepKeywords() } }>
    //               <div className={ currentStep === 6 ? "padding-bottom" : "padding-bottom-transparent" }>
    //                   <h2><FontAwesomeIcon icon={["fa", "key"]} className="nav-icons" /></h2>
    //               { i18n[selectedLanguage]['menu-keywords'] }</div>
    //           </a>
    //       </li>
    //   :
    //       <li className="nav-large unselected">
    //           <a>
    //               <div className="padding-bottom">
    //                   <h2><FontAwesomeIcon icon={["fa", "key"]} className="nav-icons" /></h2>
    //               { i18n[selectedLanguage]['menu-keywords'] }</div>
    //           </a>
    //       </li>
    // }

    return (
      <div className={ currentStep === 1 ? "nav about" : "nav" }>
        <ul>
          <li className="left-corner">
            <a id="automagic-logo" href="/" onClick={ (evt) => { evt.preventDefault(); this.props.stepAboutLogo() } }>
              automagic<br />.design
            </a>
          </li>
             { currentStep >= 1 ?
                    <li className="nav-large selected">
                        <a href="/step_about" onClick={ (evt) => { evt.preventDefault(); this.props.stepAboutLogo() } }>
                          <div className={ currentStep === 1 ? "padding-bottom" : "padding-bottom-transparent" }>
                            <h2><FontAwesomeIcon icon={["fa", "terminal"]} className="nav-icons" /></h2>
                            { i18n[selectedLanguage]['menu-about'] }
                          </div>
                        </a>
                    </li>
               :
                    <li className="nav-large unselected">
                        <a>
                          <div className="padding-bottom">
                            <h2><FontAwesomeIcon icon={["fa", "terminal"]} className="nav-icons" /></h2>
                            { i18n[selectedLanguage]['menu-about'] }
                          </div>
                        </a>
                    </li>
             }

             { (currentStep >= 2) || hasIt(selectedSector) ?
                   <li className="nav-large selected">
                         <a href="/step_sector" onClick={ (evt) => { evt.preventDefault(); this.props.stepSector() } }>
                             <div className={ currentStep === 2 ? "padding-bottom" : "padding-bottom-transparent" }>
                               <h2><FontAwesomeIcon icon={["fa", "puzzle-piece"]} className="nav-icons" /></h2>
                                 { i18n[selectedLanguage]['menu-sector'] }
                              </div>
                         </a>
                   </li>
               :
                   <li className="nav-large unselected">
                         <a>
                             <div className="padding-bottom">
                               <h2><FontAwesomeIcon icon={["fa", "puzzle-piece"]} className="nav-icons" /></h2>
                                 { i18n[selectedLanguage]['menu-sector'] }
                             </div>
                         </a>
                   </li>
             }

              { (currentStep >= 3) || hasIt(selectedValues) ?
                    <li className="nav-large selected">
                          <a href="/step_values" onClick={ (evt) => { evt.preventDefault(); this.props.stepValues() } }>
                              <div className={ currentStep === 3 ? "padding-bottom" : "padding-bottom-transparent" }>
                                <h2><FontAwesomeIcon icon={["fa", "bullseye"]} className="nav-icons" /></h2>
                                  { i18n[selectedLanguage]['menu-values'] }
                               </div>
                          </a>
                    </li>
                :
                    <li className="nav-large unselected">
                          <a>
                              <div className="padding-bottom">
                                <h2><FontAwesomeIcon icon={["fa", "bullseye"]} className="nav-icons" /></h2>
                                  { i18n[selectedLanguage]['menu-values'] }
                              </div>
                          </a>
                    </li>
              }

              { (currentStep >= 4) || hasIt(selectedEmotions) ?
                    <li className="nav-large selected">
                        <a href="/step_emotions" onClick={ (evt) => { evt.preventDefault(); this.props.stepEmotions() } }>
                            <div className={ currentStep === 4 ? "padding-bottom" : "padding-bottom-transparent" }>
                                <h2><FontAwesomeIcon icon={["fa", "heart"]} className="nav-icons" /></h2>
                            { i18n[selectedLanguage]['menu-emotions'] }</div>
                        </a>
                    </li>
                :
                    <li className="nav-large unselected">
                        <a>
                            <div className="padding-bottom">
                                <h2><FontAwesomeIcon icon={["fa", "heart"]} className="nav-icons" /></h2>
                            { i18n[selectedLanguage]['menu-emotions'] }</div>
                        </a>
                    </li>
              }

              { (currentStep >= 5) || (selectedType !== "") ?
                    <li className="nav-large selected">
                        <a href="/step_type" onClick={ (evt) => { evt.preventDefault(); this.props.stepType() } }>
                            <div className={ currentStep === 5 ? "padding-bottom" : "padding-bottom-transparent" }>
                                <h2><FontAwesomeIcon icon={["fa", "key"]} className="nav-icons" /></h2>
                            { i18n[selectedLanguage]['menu-type'] }</div>
                        </a>
                    </li>
                :
                    <li className="nav-large unselected">
                        <a>
                            <div className="padding-bottom">
                                <h2><FontAwesomeIcon icon={["fa", "key"]} className="nav-icons" /></h2>
                            { i18n[selectedLanguage]['menu-type'] }</div>
                        </a>
                    </li>
              }

              { (currentStep >= 7) || hasLogoPreviews ?
                    <li className="nav-large selected">
                        <a href="/step_preview" onClick={ (evt) => { evt.preventDefault(); this.props.stepLogoPreview() } }>
                            <div className={ currentStep === 7 ? "padding-bottom" : "padding-bottom-transparent" }>
                                <h2><FontAwesomeIcon icon={["fa", "eye"]} className="nav-icons" /></h2>
                            { i18n[selectedLanguage]['menu-your-brand'] }</div>
                        </a>
                    </li>
                :
                    <li className="nav-large unselected">
                        <a>
                            <div className="padding-bottom">
                                <h2><FontAwesomeIcon icon={["fa", "eye"]} className="nav-icons" /></h2>
                            { i18n[selectedLanguage]['menu-your-brand'] }</div>
                        </a>
                    </li>
              }

              { (currentStep >= 8) || hasLogoPreviews ?
                    <li className="nav-large selected download">
                        <a href="/step_download" onClick={ (evt) => { evt.preventDefault(); this.props.stepLogoDownload() } }>
                            <div className={ currentStep === 8 ? "padding-bottom-download" : null }>
                                <h2><FontAwesomeIcon icon={["fa", "check-square"]} className="nav-icons" /></h2>
                            { i18n[selectedLanguage]['menu-download'] }</div>
                        </a>
                    </li>
                :
                    <li className="nav-large unselected">
                        <a>
                            <div className="padding-bottom">
                                <h2><FontAwesomeIcon icon={["fa", "check-square"]} className="nav-icons" /></h2>
                            { i18n[selectedLanguage]['menu-download'] }</div>
                        </a>
                    </li>
              }
          <li className="nav-large right-corner">
            <a href="/dashboard">
              <div className="padding-bottom">
                  <h2><FontAwesomeIcon icon={["fa", "user-circle"]} className="nav-icons" /></h2>
                  { i18n[selectedLanguage]['menu-dashboard'] }</div>

            </a>
          </li>
          <li className="nav-small right-corner">
            <a href="/dashboard">
                  <h2><FontAwesomeIcon icon={["fa", "user-circle"]} className="nav-icons" /></h2>
            </a>
          </li>
        </ul>

      </div>
    )
  }

  renderContent() {
    let currentStepJSX
    if (this.props.newLogo.currentStep === 1) {
      currentStepJSX = <AboutLogo key="about-logo" />
      // currentStepJSX = <LogoPreview key="logo-preview" />
    }
    else if (this.props.newLogo.currentStep === 2)
      currentStepJSX = <SectorSelector key="sector-selector" />
    else if (this.props.newLogo.currentStep === 3)
      currentStepJSX = <ValuesSelector key="values-selector" />
    else if (this.props.newLogo.currentStep === 4)
      currentStepJSX = <EmotionsSelector key="emotions-selector" />
    // else if (this.props.newLogo.currentStep === 4)
    //   currentStepJSX = <ColorPalettesSelector key="color-palettes-selector" />
    // else if (this.props.newLogo.currentStep === 5)
    //   currentStepJSX = <TypefacesSelector key="typefaces-selector" />
    else if (this.props.newLogo.currentStep === 5)
      currentStepJSX = <TypeSelector key="type-selector" />
    else if (this.props.newLogo.currentStep === 6)
      currentStepJSX = <KeywordsSelector key="keywords-selector" />
    else if (this.props.newLogo.currentStep === 7)
      currentStepJSX = <LogoPreview key="logo-preview" />
    else if (this.props.newLogo.currentStep === 8)
      currentStepJSX = <LogoDownload key="logo-download" />

    return ( currentStepJSX )
    // return (
    //   <CSSTransitionGroup
    //     transitionName="slide"
    //     transitionAppear={false}
    //     transitionAppearTimeout={500}
    //     transitionEnterTimeout={0}
    //     transitionLeaveTimeout={0}
    //     transitionEnter={true}
    //     transitionLeave={true}>
    //
    //     { currentStepJSX }
    //
    //   </CSSTransitionGroup>
    // )
  }

  handleBackClick(e) {
    e.preventDefault()
    if (this.props.newLogo.currentStep === 2)
      this.props.stepAboutLogo()
    else if (this.props.newLogo.currentStep === 3)
      this.props.stepSector()
    else if (this.props.newLogo.currentStep === 4)
      this.props.stepValues()
    else if (this.props.newLogo.currentStep === 5)
      this.props.stepEmotions()
    // else if (this.props.newLogo.currentStep === 5)
    //   this.props.stepColorPalettes()
    // else if (this.props.newLogo.currentStep === 6)
    //   this.props.stepTypefaces()
    else if (this.props.newLogo.currentStep === 6)
      this.props.stepType()
    else if (this.props.newLogo.currentStep === 7)
      this.props.stepType()
    else if (this.props.newLogo.currentStep === 8)
      this.props.stepLogoPreview()
  }

  handleNextClick(e) {
    e.preventDefault()
    if (this.props.newLogo.currentStep === 1)
      this.props.stepSector()
    else if (this.props.newLogo.currentStep === 2)
      this.props.stepValues()
    else if (this.props.newLogo.currentStep === 3)
      this.props.stepEmotions()
    // else if (this.props.newLogo.currentStep === 3)
    //   this.props.stepColorPalettes()
    // else if (this.props.newLogo.currentStep === 4)
    //   this.props.stepTypefaces()
    else if (this.props.newLogo.currentStep === 4)
      this.props.stepType()
    // else if (this.props.newLogo.currentStep === 5)
    //   this.props.stepKeywords()
    // else if (this.props.newLogo.currentStep === 4)
    //   this.props.stepKeywords()
    else if (this.props.newLogo.currentStep === 6)
      this.props.stepLogoPreview()
    else if (this.props.newLogo.currentStep === 7)
      this.props.stepLogoDownload()
  }

  renderActionButtons() {
    let backButton
    let { selectedLanguage } = this.props.newLogo.userPrefs
    if ((this.props.newLogo.currentStep >= 2) &&
        (this.props.newLogo.currentStep <= MAX_STEPS)) {
      backButton = (
       <a className="side-button" href="/prev" onClick={ this.handleBackClick.bind(this) }>
         <span className="label-bg">
          <FontAwesomeIcon icon={["fas", "chevron-left"]} className={ this.props.newLogo.currentStep === 1 ? "side-nav-icons about" : "side-nav-icons" } />
          </span>
       </a>
      )
    }

    let nextButton
    if (this.props.newLogo.currentStep <= MAX_STEPS-2) {
      if ((this.props.newLogo.currentStep === 1 && this.props.newLogo.userPrefs.logoName.length > 0) ||
          (this.props.newLogo.currentStep === 2 && this.props.newLogo.userPrefs.selectedSector.length > 0) ||
          (this.props.newLogo.currentStep === 3 && this.props.newLogo.userPrefs.selectedValues.length > 0) ||
          (this.props.newLogo.currentStep === 4 && this.props.newLogo.userPrefs.selectedEmotions.length > 0) ||
          (this.props.newLogo.currentStep === 6 && this.props.newLogo.userPrefs.selectedKeywords[0].length > 0) ||
          (this.props.newLogo.currentStep === 6 && this.props.newLogo.userPrefs.selectedKeywords[1].length > 0) ||
          (this.props.newLogo.currentStep === 6 && this.props.newLogo.userPrefs.selectedKeywords[2].length > 0)) {
        nextButton = (
         <a className="side-button" href="/next" onClick={ this.handleNextClick.bind(this) }>
           <span className="label-bg">
            <FontAwesomeIcon icon={["fas", "chevron-right"]} className={ this.props.newLogo.currentStep === 1 ? "side-nav-icons about" : "side-nav-icons" }  />
            </span>
         </a>
        )
      }
    } else if (this.props.newLogo.currentStep === 7) {
      return (
        <div className="buy-button-wrapper">
          <a href="/next" className="buy-button" onClick={ this.handleNextClick.bind(this) }>
            { i18n[selectedLanguage]['buy-now'] }
          </a>
        </div>
      )
    }

    return (
      <div>
        <div className="left-side-nav">
          { backButton }
        </div>

        <div className="right-side-nav">
          <CSSTransitionGroup
            transitionName="slide-right"
            transitionAppear={false}
            transitionAppearTimeout={500}
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}
            transitionEnter={true}
            transitionLeave={true}>

              { nextButton}

          </CSSTransitionGroup>
        </div>
      </div>
    )
  }

  renderModal() {
    let { availableLogoPreviews, availableIcons } = this.props.newLogo
    let { authenticatedUser } = this.props
    if (authenticatedUser) return null

    if (availableLogoPreviews) {
      let { error } = availableLogoPreviews
      if (error) {
        if (error.status === 401) {
          return (
            <div className="modal">
              <Sign attemptedAction="fetchLogoPreviews"/>
            </div>
          )
        }
        // TODO: Threat other kinds of errors
      }
      // if (loading) {
      //   return (
      //     <div className="modal">
      //       <div className="modal-spinner">
      //         <Spinner name='ball-grid-pulse' color="#fff" fadeIn="none" />
      //       </div>
      //     </div>
      //   )
      // }
    }
    if (availableIcons) {
      if (availableIcons.error) {
        if (availableIcons.error.status === 401) {
          return (
            <div className="modal">
              <Sign attemptedAction="requestIcons"/>
            </div>
          )
        }
        // TODO: Threat other kinds of errors
      }
      // if (availableIcons.loading) {
      //   return (
      //     <div className="modal">
      //       <div className="modal-box">
      //     { i18n[selectedLanguage]['loading'] }
      //       </div>
      //     </div>
      //   )
      // }
    }
    return null
  }

  render() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
      <div>
        { this.renderModal() }

        { this.renderStepsSelector() }

        { this.renderActionButtons() }

        { this.renderContent() }

      {
        <div>
         <div className="bottom bottom-left">
          <a href="/about">{ i18n[selectedLanguage]['bottom-about'] }</a> |
          <a href="/pricing"> { i18n[selectedLanguage]['bottom-pricing'] }</a> |
          <a href="mailto:contact@automagic.design"> { i18n[selectedLanguage]['bottom-contact'] }</a> |
          <a href="/tos"> { i18n[selectedLanguage]['bottom-tos'] }</a> |
          <a href="/privacy"> { i18n[selectedLanguage]['bottom-privacy'] }</a>
         </div>
         <div className="bottom bottom-right">
          <a className="language-selector" href="/en" onClick={ (evt) => { evt.preventDefault(); this.props.updateLanguage('en') } }> EN</a> |
          <a className="language-selector" href="/pt" onClick={ (evt) => { evt.preventDefault(); this.props.updateLanguage('pt') } }> PT-BR</a>
         </div>
        </div>
      }

      </div>
    )
  }
}

export default NewLogo



// WEBPACK FOOTER //
// ./src/components/NewLogo.js